<template>
  <div>
    <h4>{{ "time_ower" | setText("Осталось секунд:") }} {{ limitSecond }}</h4>
    <div class="row">
      <!-- <div class="col-12 col-md-12">
        <fg-input
          :type="`text`"
          :label="`Код из смс TBC_FIN`"
          :labelKey="`sms_code_tbc_fin`"
          v-model="data.code"
        ></fg-input>
      </div> -->
      <div v-if="value.svgate_otp_id" class="col-12 col-md-12">
        <fg-input
          :type="`text`"
          :label="`Код из смс 4800`"
          :labelKey="`sms_code_4800`"
          v-model="data.codeUZCARD"
        ></fg-input>
      </div>
    </div>

    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {
    limitSecond(val) {
      if (val < 1) {
        this.$emit("setStep", "pre-scoring");
      }
    },
  },
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {
    setInterval(() => {
      this.limitSecond--;
    }, 1000);
  },
  methods: {
    send() {
      this.$loading(true);
      let data = {};
      data["pre_scoring_user_id"] = this.value["pre_scoring_user_id"];
      data["otp_id"] = this.value["otp_id"];
      // data["otp_value"] = this.data.code;
      if (this.value["svgate_otp_id"]) {
        data["svgate_otp_id"] = this.value["svgate_otp_id"];
        data["svgate_otp_value"] = this.data.codeUZCARD;
      }

      this.$http({
        url: `${this.partner["endpoint_url"]}confirm-pre-scoring`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              exchange_id: response.data.loan_id,
              step: "get-offers-limit",
            });
            this.$emit("setStep", "get-offers-limit");
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {
        code: null,
        codeUZCARD: null,
      },
      limitSecond: 120,
    };
  },
};
</script>

